import { FC } from "react";
import { Box, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from "react-i18next";

interface DownloadPdfButtonProps {
  pdfFileName: string; // Явно указываем, что здесь только строка (null уже отфильтрован в родительском компоненте)
  carId: number;
}

const DownloadPdfButton: FC<DownloadPdfButtonProps> = ({ pdfFileName, carId }) => {
  const { t } = useTranslation("explore");

  const handleDownload = () => {
    // Создаем ссылку для скачивания из папки public
    const link = document.createElement('a');
    link.href = `/Files_pdf/${pdfFileName}`;
    link.download = pdfFileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        borderLeft: { xs: "", md: "#fff solid 1px" },
        borderTop: { xs: "#fff solid 1px", md: "none" },
        px: { xs: 0, md: 3 },
        pt: { xs: "4vw", md: 0 },
      }}
    >
      <Button
        variant="outlined"
        startIcon={<DownloadIcon />}
        onClick={handleDownload}
        sx={{
          color: "#fff",
          borderColor: "#fff",
          borderRadius: "8px",
          px: 3,
          py: 1.5,
          fontSize: { xs: "3.5vw", md: "16px" },
          fontWeight: 600,
          fontFamily: "Montserrat",
          textTransform: "none",
          "&:hover": {
            borderColor: "#fff",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        }}
      >
        {t("download_pdf")}
      </Button>
      {/* <Typography
        sx={{
          fontSize: { xs: "3vw", md: "14px" },
          fontWeight: 400,
          fontFamily: "Montserrat",
          color: "#fff",
          textAlign: "center",
          mt: 1,
          opacity: 0.8,
        }}
      >
        {t("brochure")}
      </Typography> */}
    </Box>
  );
};

export default DownloadPdfButton; 